import React, { useEffect, useState } from 'react'
import { useLanguage } from '../context/languageContext';
import httpClient from '../shared/axios';
import parse from "html-react-parser";
import { getTrimmedDescription } from '../shared';
import { NavLink } from 'react-router-dom';

export default function Activity() {
    const { language } = useLanguage();
    const [data, setData] = useState([])
    useEffect(() => {
        const getActivities = async () => {
            const { data } = await httpClient.get(`/daily-activity/?lang=${language === 'oz' ? 'uz-cyrl' : language}`)
            setData(data)
        }
        getActivities()

    }, [language])
    return (
        <div className='Activity container py-5'>
            <div className="row">
                {data && data.map((item) => (
                    <NavLink to={`/daily-activity/${item.id}`} key={item.id} className="col-12 mb-3">
                        <div className="row">
                            <div className="col-3">
                                {!!item.images[0]?.image ? <img className='w-100' src={item.images[0].image} alt={item.title} /> : null}
                            </div>

                            <div className="col-9">
                                <h3 className='my-3'>{item.title}</h3>
                                <h5>{parse(getTrimmedDescription(item.description))} </h5>
                            </div>
                        </div>
                    </NavLink>
                ))}
            </div>
        </div>
    )
}
